<template>
  <section class="member">
    <router-link
      target="_blank"
      class="member-item"
      :class="{'userType2':item.userType === 2 && item.isCertification === 1}"
      :to="'/peopleCenter/'+item.userId"
    >
      <img class="member-img" :src="item.avatar | imageUrl('/static/profile_img_default.png', 190, 190)" />
      <div class="member-content">
        <h4>{{item.nickname}}</h4>
        <div class="author-title">
          <img v-if="item.area" src="/static/v2/match/location_icon.png" alt />
          <span class="areaName" v-if="item.area">{{item.area}}</span>
          <div class="majiang">
            <router-link @click.stop :to="'/peopleCenter/'+item.userId+'&activeIndex=6'">
              <span>{{$t('global.作品')}}</span>
              <b>{{item.videoCount}}</b>
            </router-link>
            <router-link @click.stop :to="'/peopleCenter/'+item.userId+'&activeIndex=6'">
              <span>{{$t('global.粉丝')}}</span>
              <b>{{item.fansCount}}</b>
            </router-link>
          </div>
        </div>
        <p>{{item.signature}}</p>
        <div class="member-bottom">
          <button
            :key="1"
            class="member-focus following"
            @mouseenter="toggleTitle1"
            v-if="item.isFollow"
            @mouseleave="toggleTitle2"
            @click.prevent.stop="Follow(item)"
          >{{$t('global.已关注')}}</button>
          <button
            :key="2"
            v-else
            class="member-focus add-follow-2"
            @click.prevent.stop="Follow(item)"
          >{{$t('global.关注')}}</button>
        </div>
      </div>
    </router-link>

    <div class="memberightside">
      <ul>
        <li v-for="video in item.items.slice(0,3)" :key="video.videoId">
          <router-link :to="'/video/detail?id='+video.videoId">
            <img :src="video.thumb | imageUrl('', 320, 180)" />
            <p>{{video.title}}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    Follow(item) {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push("/login");
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(res => {
          if (res.code === "OK") {
            item.isFollow = !item.isFollow;
            if (item.isFollow) {
              this.$message.success(res.message);
            } else {
              this.$message(res.message);
            }
          }
        });
    },
    toggleTitle1() {
      event.target.innerHTML = this.$t("global.取消关注");
      event.target.classList.add("focus");
    },
    toggleTitle2() {
      event.target.innerHTML = this.$t("global.已关注");
      event.target.classList.remove("focus");
    }
  }
};
</script>

<style lang="stylus" scoped>
.member {
  display: flex;
  flex-direction: row;

  .member-item {
    display: flex;
    flex-direction: row;
    width: 470px;
    min-width: 470px;
    position: relative;

    &.userType2::before {
      content: '';
      left: 75px;
      top: 70px;
      position: absolute;
      width: 20px;
      height: 20px;
      background: url('/static/v2/match/Verified_icon_blue_20.png');
      background-size: 20px;
    }

    .member-img {
      width: 93px;
      height: 93px;
      min-width: 95px;
      border-radius: 50%;
      margin-right: 20px;
      border: 1px solid #f5f5f5;
    }

    .member-content {
      width: 295px;

      h4 {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #0A0A0A;
      }

      .author-title {
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 6px 0;

        img {
          width: 10px;
          height: 13px;
          margin-right: 4px;
        }

        .areaName {
          margin: 5px 15px 5px 0;
          padding-right: 15px;
          height: 10px;
          line-height: 10px;
          font-size: 12px;
          border-right: 1px solid #E0E0E0;
        }

        .majiang {
          margin: 5px 0;
          padding-right: 15px;
          height: 10px;
          line-height: 10px;

          a {
            margin-right: 10px;

            span {
              color: #999;
              font-size: 12px;
            }

            b {
              color: #999;
            }
          }
        }
      }

      &>p {
        font-family: PingFangSC-Regular, PingFang SC;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 20px;
        max-height: 40px;
      }

      .member-bottom {
        margin-top: 15px;

        button {
          border: 1px solid #2026CC;
          color: #2026CC;
          padding: 0 12px;
          height: 24px;
          font-size: 12px;
          background: #fff;

          &.add-follow-2::before {
            content: '';
            display: inline-block;
            width: 7px;
            height: 7px;
            background: url('/static/v2/user_follow_btn_plus.png');
            background-size: 7px;
            margin-right: 4px;
            vertical-align: middle;
            margin-top: -2px;
          }

          &.following {
            border-color: #B8B8B8;
            color: #B8B8B8;

            &.focus {
              color: #999;
              border-color: #999;
            }
          }
        }
      }
    }
  }

  .memberightside {
    ul {
      display: flex;
      flex-direction: row;
      width: 525px;

      li {
        width: 160px;
        margin-right: 15px;

        a {
          img {
            width: 160px;
            height: 90px;
          }

          p {
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 17px;
            font-size: 12px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            padding-top: 5px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/peopleCenter/MemberCard.vue